export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const maskEmail = (email: string): string => {
  const [username, domain] = email.split('@');
  if (!username || !domain) return email;

  // Determine how many characters to show (min 1, max 4)
  const visibleCount = Math.min(
    Math.max(1, Math.floor(username.length / 3)),
    4
  );
  const visiblePart = username.slice(0, visibleCount);
  const maskedPart = 'x'.repeat(username.length - visibleCount);

  return `${visiblePart}${maskedPart}@${domain}`;
};
